import { normalizeSpecimenIdentifier } from "./specimenIdentifiers";

interface UnresolvedWorkListStain {
  specimenNumber: string;
  requestedStain: string;
}

interface MappedWorkListStain {
  expectedSpecimenNumber?: string;
  specimenNumber: string;
}

export function renameMappedWorkListStains<T extends MappedWorkListStain>(
  stains: T[],
  expectedSpecimenNumber: string | undefined,
  nextSpecimenNumber: string
): T[] {
  if (!expectedSpecimenNumber) return stains;
  const expectedKey = normalizeSpecimenIdentifier(
    expectedSpecimenNumber
  ).toLowerCase();
  return stains.map((stain) =>
    normalizeSpecimenIdentifier(stain.expectedSpecimenNumber).toLowerCase() ===
    expectedKey
      ? { ...stain, specimenNumber: nextSpecimenNumber }
      : stain
  );
}

export function filterActiveUnresolvedWorkListStains<
  T extends UnresolvedWorkListStain
>(unresolved: T[], specimens: object[]): T[] {
  const hasExplicitMappings = specimens.some((specimen) =>
    Object.prototype.hasOwnProperty.call(specimen, "expectedSpecimenNumber")
  );
  if (!hasExplicitMappings) return unresolved;

  const activeExpectedIdentifiers = new Set(
    specimens
      .map((specimen) =>
        normalizeSpecimenIdentifier(
          (specimen as { expectedSpecimenNumber?: string })
            .expectedSpecimenNumber
        )
      )
      .filter(Boolean)
      .map((identifier) => identifier.toLowerCase())
  );
  return unresolved.filter((stain) =>
    activeExpectedIdentifiers.has(
      normalizeSpecimenIdentifier(stain.specimenNumber).toLowerCase()
    )
  );
}
